import { Helmet } from 'react-helmet-async'

import PageLayout from '../components/layout/PageLayout.jsx'
import HeroSection from '../components/home/HeroSection.jsx'
import CompanyIntroduction from '../components/home/CompanyIntroduction.jsx'
import ExpertiseSection from '../components/home/ExpertiseSection.jsx'
import ApiManufacturingSection from '../components/home/ApiManufacturingSection.jsx'
import RAndDSection from '../components/home/RAndDSection.jsx'
import StatisticsCounterSection from '../components/home/StatisticsCounterSection.jsx'
import WhyChooseUsSection from '../components/home/WhyChooseUsSection.jsx'
import IndustriesServedSection from '../components/home/IndustriesServedSection.jsx'
import CTASection from '../components/home/CTASection.jsx'
import HomeSlider from '../components/home/HomeSlider.jsx'
import FounderProfileSection from '../components/home/FounderProfileSection.jsx'


export default function Home() {
  return (
    <PageLayout>
      <Helmet>
        <title>Ritik Medicare Pvt. Ltd. | API Manufacturing & Pharmaceutical Solutions</title>
        <meta
          name="description"
          content="Ritik Medicare Pvt. Ltd. offers API development, process development, custom synthesis, contract manufacturing, regulatory support and technical consultancy in Pune, Maharashtra."
        />
        <meta property="og:title" content="Ritik Medicare Pvt. Ltd." />
        <meta property="og:description" content="API Manufacturing & Pharmaceutical Solutions" />
      </Helmet>

      {/* Home page company logo (text mark placeholder) */}
      {/* <div className="relative mx-auto max-w-7xl px-4 pt-8">
        <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white/70 backdrop-blur px-5 py-3 w-fit shadow-sm">
          <div className="text-brand-primary font-extrabold text-xl">RM</div>
          <div className="hidden sm:block text-slate-700 text-sm font-semibold">Ritik Medicare Pvt. Ltd.</div>
        </div>
      </div> */}

      <HomeSlider />
      
      <FounderProfileSection />
     
    </PageLayout>

  )
}


